"use client";
import React, { useState, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { CategoryIndex } from "oddsgate-ds";
import { WpClientRequest } from "@/lib/wordpress/wpClientRequest";
import { useGlobalContext } from "@/lib/globalContext";

const BlockCategoryIndex: React.FC = () => {
  const [categories, setCategories] = useState<
    { name: string; slug: string }[]
  >([]);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const router = useRouter();

  useEffect(() => {
    WpClientRequest({
      post_type: "glossary",
      variables: {
        limit: -1,
      },
    })
      .then((res) => {
        if (
          res.categories &&
          Array.isArray(res.categories) &&
          res.categories[0]?.items &&
          Array.isArray(res.categories[0].items)
        ) {
          const mappedCategories = res.categories[0].items.map((cat: any) => ({
            name: cat.name,
            slug: cat.slug,
          }));
          setCategories(mappedCategories);
        } else {
          setCategories([]);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch categories", err);
        setCategories([]);
      });
  }, []);

  const glossaryRoutes = {
    pt: "/glossario",
    es: "/glosario",
    en: "/glossary",
  };
  const state = useGlobalContext();
  type Lang = "pt" | "es" | "en";
  const lang: Lang = (state?.lang as Lang) || "en";

  const handleCategoryChange = (categorySlug: string | null) => {

    setSelectedCategory(categorySlug);
    if (categorySlug) {
        const categorySlugUppercase =
          categorySlug.length === 1 && /[a-zA-Z]/.test(categorySlug)
            ? categorySlug.toUpperCase()
            : categorySlug;
      const finalUrl = `${glossaryRoutes[lang]}?category=${encodeURIComponent(
        categorySlugUppercase
      )}`;
      router.push(finalUrl);
    } else {
      router.push(`${glossaryRoutes[lang]}`);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CategoryIndex
        categories={categories}
        selectedCategory={selectedCategory}
        onChange={handleCategoryChange}
      />
    </div>
  );
};

export default BlockCategoryIndex;
